/*
 * Date de livraison estimee — recalcul sur l'horloge du visiteur.
 *
 * Liquid l'a deja ecrite dans le HTML : c'est ce que voit un moteur, et ce qui
 * s'affiche sans JavaScript. Mais une page servie depuis un cache peut avoir
 * ete produite plusieurs heures — parfois plusieurs jours — auparavant, et la
 * date afficherait alors un decalage.
 *
 * Ce script la refait donc a partir de la date du jour. Il ne touche a rien
 * d'autre : meme delai, meme formulation, seule la reference temporelle change.
 */
(() => {
  const cibles = document.querySelectorAll('[data-livraison-estimee]');
  if (!cibles.length) return;

  /* `toLocaleDateString` plutot qu'un tableau de mois ecrit a la main : il
   * connait les accents, les elisions et les regles de chaque langue. On lui
   * passe la langue du document, pas une valeur figee — le jour ou la boutique
   * ouvre en anglais, la date suit sans une ligne de plus. */
  const langue = document.documentElement.lang || 'fr';
  const format = new Intl.DateTimeFormat(langue, { day: 'numeric', month: 'long' });

  cibles.forEach((cible) => {
    const jours = Number.parseInt(cible.dataset.jours, 10);
    if (!Number.isFinite(jours) || jours <= 0) return;

    const date = new Date();
    date.setDate(date.getDate() + jours);

    /* `datetime` est mis a jour lui aussi : il est lu par les machines, et le
     * laisser sur la valeur du rendu ferait dire deux choses differentes au
     * meme element. */
    const iso = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    cible.setAttribute('datetime', iso);
    cible.textContent = format.format(date);
  });
})();
